export const ADD_AUDIT_CONNECTOR = 'organization/auditconnectors/ADD'
export const ADD_AUDIT_CONNECTOR_SUCCESS = `${ADD_AUDIT_CONNECTOR}_SUCCESS`

export const GET_AUDIT_CONNECTOR = 'organization/auditconnectors/GET'
export const GET_AUDIT_CONNECTOR_SUCCESS = `${GET_AUDIT_CONNECTOR}_SUCCESS`

export const REMOVE_AUDIT_CONNECTOR = 'organization/auditconnectors/REMOVE'
export const REMOVE_AUDIT_CONNECTOR_SUCCESS = `${REMOVE_AUDIT_CONNECTOR}_SUCCESS`

export const CLEAR_AUDIT_CONNECTOR_SECRET = 'organization/auditconnectors/CLEAR_AUDIT_CONNECTOR_SECRET'
